import { Loader2Icon } from "lucide-react";
import type React from "react";

import { cn } from "@krea/shared/utils";

function Spinner({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof Loader2Icon>) {
  return (
    <div className="tw-flex tw-items-center tw-justify-center">
      <Loader2Icon
        role="status"
        aria-label="Loading"
        strokeWidth={2.5}
        className={cn("tw-size-14 tw-animate-spin tw-text-primary", className)}
        {...props}
      />
    </div>
  );
}

export { Spinner };
